import React, { useState } from "react";
import { signOut } from 'firebase/auth';
import { auth } from '../../Logica/firebase/firebase';
import { authFetch } from '../../../utils/authFetch';

const ConfirmarInscripcionButton = ({ email, materia, onConfirmado }) => {
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null); 

  const manejarConfirmacion = async () => {
    if (!email || !materia?.ID) return;

    setEnviando(true);
    setResultado(null);

    try {
      const url = `https://api.micrositec.com/api/register`;
      const respuesta = await authFetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idEmail: email,
          idMat: String(materia.ID),
        }),
      });
      const data = await respuesta.json();
      if (respuesta.ok && data.ok) {
        setResultado({
          tipo: "exito",
          codigo: data.message,
        });
      } else {
        const sinCupo = data.message?.toLowerCase().includes("cupo");
        setResultado({
          tipo: "error",
          sinCupo,
          titulo: sinCupo ? "Sin cupo disponible" : "Error",
          mensaje: sinCupo
            ? "❌ El grupo que intentas registrar ya no tiene cupos, intenta seleccionando otra actividad"
            : `❌ Error: ${data.message || "No se pudo inscribir"}`,
        });
      }
    } catch (error) {
      console.error("Error al inscribir:", error);
      setResultado({
        tipo: "error",
        mensaje: "⚠️ Error de red al enviar solicitud.",
      });
    }

    setEnviando(false);
  };
  
  const handleLogout = async () => {
      try {
        await signOut(auth);     // Cierra la sesión en Firebase
        cerrarModal();               // Cierra el modal después
      } catch (error) {
        console.error("Error al cerrar sesión:", error);
      }
    };

  const cerrarModal = () => {
    setResultado(null);
    onConfirmado?.(); // reiniciar selección desde HomePage
  };

  return (
    <div className="mt-3 text-center">
      <button
        className="btn btn-success"
        onClick={manejarConfirmacion}
        disabled={enviando}
      >
        {enviando ? "Enviando..." : "Registrar actividad LiFE"}
      </button>

      {/* Modal */}
      {resultado && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content text-center">
              <div
                className={`modal-header ${
                  resultado.tipo === "exito" ? "bg-success" : "bg-danger"
                } text-white`}
              >
                <h5 className="modal-title">
                  {resultado.tipo === "exito" ? "✅ ¡Registro finalizado!" : resultado.titulo || "Error"}
                </h5>
              </div>
              <div className="modal-body">
                {resultado.tipo === "exito" ? (
                  <div>
                    <p className="mb-2">Código de registro</p>
                    <div
                      className="d-inline-block bg-light border border-success rounded-3 px-4 py-2 fs-3 fw-bold text-success"
                      style={{ letterSpacing: "2px" }}
                    >
                      {resultado.codigo}
                    </div>
                    <p className="mt-3 mb-0">
                      <strong>Inscripción sujeta a no empalme con materias académicas</strong>
                    </p>
                  </div>
                ) : (
                  <p>{resultado.mensaje}</p>
                )}
              </div>
              <div className="modal-footer justify-content-center">
                {resultado.sinCupo ? (
                  // Sin cupo no es una sesión terminada: se deja abierta para
                  // que pueda elegir otra materia, en vez de cerrar sesión.
                  <button className="btn btn-secondary" onClick={cerrarModal}>
                    Elegir otra actividad
                  </button>
                ) : (
                  <button className="btn btn-secondary" onClick={handleLogout}>
                    Finalizar
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmarInscripcionButton;
